module.exports = __webpack_public_path__ + "static/media/sf-cover@2x.a66d6c5c.webp";